import ContentPlaceholder from "../../ContentPlaceholder/component";

export const makeContentLayout = function (options = {}) {
    const {
        wrapperClasses = "",
        contentClasses = "",
        flags = [],
        ContentComponent = ContentPlaceholder,
    } = options;

    return Object.freeze({
        wrapperClasses,
        contentClasses,
        ContentComponent,
        flags,
        with: contentLayoutWith,
    });
};

export const isContentLayout = (obj) => {
    if (obj.with) {
        return obj.with === contentLayoutWith;
    }
    return false;
};

export const contentLayoutWith = function (options) {
    const {
        ContentComponent,
        wrapperClasses,
        contentClasses,
        acceptsComponents,
        flags,
    } = options;
    const defined = Object.fromEntries(
        Object.entries({
            ContentComponent,
            wrapperClasses,
            contentClasses,
            acceptsComponents,
            flags,
        }).filter(([, value]) => value !== undefined)
    );
    return makeContentLayout({ ...this, ...defined });
};
